var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"no-margin",attrs:{"type":"none"}},_vm._l((_vm.headerContent),function(content,index){return _c('li',{key:index},[(
                content['content_type'] == 'link' ||
                    content['content_type'] == 'category'
            )?_c('a',{attrs:{"href":((_vm.$root.baseUrl) + "/" + (content['page_link'])),"target":content['link_target'] ? '_blank' : '_self'},domProps:{"textContent":_vm._s(content.title)}}):_vm._e()])}),0)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bec859f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Resources/assets/js/UI/components/header-right-side.vue
// module id = +0U5
// module chunks = 0